<div class="grid grid-cols-12 gap-4">
  <div class="col-span-12">
    <microsec-card [isNestedCard]="true" [isTableCard]="true">
      <microsec-common-table
        #dt
        [cols]="cols"
        [values]="values"
        [loading]="isLoading"
        [scrollHeight]="'30rem'"
        [paginator]="false"
        [cellTemplate]="cellTemplate"
        itemName="Service"
        [containerHeaderRightTemplate]="containerHeaderRightTemplate">
      </microsec-common-table>
      <ng-template let-col="col" let-rowData="rowData" #cellTemplate>
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchDefault>
            {{ rowData[col.field] || '-' }}
          </ng-container>
        </ng-container>
      </ng-template>
    </microsec-card>
  </div>
</div>

<ng-template #containerHeaderRightTemplate>
  <div class="flex flex-wrap items-center gap-2">
    <p-button
      type="button"
      icon="fa fa-file-export"
      severity="primary"
      pTooltip="Generate Report"
      tooltipPosition="bottom"
      appendTo="body"
      severity="primary"
      (onClick)="openGenerateReportDialog()">
    </p-button>
  </div>
</ng-template>
